import { NS3451, OMUK } from '@consigli/types';

export type FolderStructureStandard = NS3451 | OMUK;

export enum FolderStructureStandards {
  NS3451 = 'ns3451',
  OMUK = 'OMUK',
}

export const mappingDict = {
  ns3451: {
    UNCATEGORIZED: 'Ukategorisert',
    NS3451_1: '1 Forvaltning',
    NS3451_11: '11 Dokumenter for Forvaltning',
    NS3451_111: '111 Kjøpskontrakter',
    NS3451_112: '112 Leiekontrakter',
    NS3451_113: '113 Drifts- og vedlikeholds- og serviceavtaler',
    NS3451_114: '114 Vedtekter for boligselskap',
    NS3451_115: '115 Garantidokument',
    NS3451_116: '116 Protokoller',
    NS3451_117: '117 Adresselister',
    NS3451_118: '118 Forsikringer',
    NS3451_12: '12 Juridiske og offentlige dokumenter',
    NS3451_121: '121 Matrikkelinformasjon',
    NS3451_122: '122 Seksjoneringsplan',
    NS3451_123: '123 Offentligrettslige betingelser for drift av eiendommen',
    NS3451_124: '124 Ferdigattest og midlertidig brukstillatelse',
    NS3451_13: '13 Tomt',
    NS3451_131: '131 Tomtebefaring',
    NS3451_132: '132 Beskyttelse av vegetasjon og vekstjord',
    NS3451_133: '133 Målinger og rapporter',
    NS3451_14: '14 Dimensjonering',
    NS3451_141: '141 Energiberegninger',
    NS3451_142: '142 Bærekraftsberegninger',
    NS3451_143: '143 Statiske beregninger',
    NS3451_144: '144 Inneklima (lys, luft, lyd og temperatur)',
    NS3451_145: '145 Målinger (lys, radon og tetthet)',
    NS3451_146: '146 Tilpasningsdyktighet',
    NS3451_15: '15 Miljø',
    NS3451_151: '151 Miljøkonsept',
    NS3451_152: '152 Miljøsertifisering',
    NS3451_153: '153 Klimaregnskap',
    NS3451_154: '154 Energiattest',
    NS3451_155: '155 Miljøkartlegging og sanering',
    NS3451_156: '156 Skadedyr',
    NS3451_16: '16 Tegninger, planer og kart',
    NS3451_161: '161 Arkitekt Plantegninger',
    NS3451_162: '162 Arkitekt Detaljtegninger',
    NS3451_163: '163 Arkitekt Snitt Og Fasade',
    NS3451_164: '164 Byggtekniske Plantegninger',
    NS3451_165: '165 Byggtekniske Detaljer',
    NS3451_166: '166 VVS Plantegninger',
    NS3451_167: '167 VVS Systemskjemaer',
    NS3451_168: '168 EL Plantegninger',
    NS3451_169: '169 EL Systemskjemaer',
    NS3451_17: '17 Branndokumentasjon',
    NS3451_171: '171 Brannkonsept',
    NS3451_172: '172 Rømningsplan',
    NS3451_173: '173 Orienteringsplan',
    NS3451_18: '18 Sikkerhet',
    NS3451_181: '181 Sikkerhet mot naturskader',
    NS3451_182: '182 Graderingsspesifikasjon',
    NS3451_183: '183 Andre sikkerhetsvurderinger',
    NS3451_19: '19 Drift og vedlikehold',
    NS3451_191: '191 Drifts- og vedlikeholdsplan for bygning',
    NS3451_192: '192 Opplæringsplaner (kvittert gjennomført)',
    NS3451_193: '193 Renholdsplan',
    NS3451_194: '194 Renovasjonsplan',
    NS3451_195: '195 Prøvedrift',
    NS3451_196: '196 Brøyteplan',
    NS3451_197: '197 Drifts- og vedlikeholdsplan utomhus',
    NS3451_2: '2 Bygning',
    NS3451_21: '21 Grunn og fundamenter',
    NS3451_211: '211 Klargjøring av tomt',
    NS3451_212: '212 Byggegrop',
    NS3451_213: '213 Grunnforsterkning',
    NS3451_214: '214 Støttekonstruksjoner',
    NS3451_215: '215 Pelefundamentering',
    NS3451_216: '216 Direkte fundamentering',
    NS3451_217: '217 Drenering',
    NS3451_218: '218 Utstyr og komplettering for grunn og fundamenter',
    NS3451_219: '219 Andre deler av grunn og fundamenter',
    NS3451_22: '22 Bærende konstruksjoner',
    NS3451_221: '221 Rammer',
    NS3451_222: '222 Søyler',
    NS3451_223: '223 Bjelker',
    NS3451_224: '224 Avstivende konstruksjoner',
    NS3451_225: '225 Brannbeskyttelse av bærende konstruksjoner',
    NS3451_226: '226 Kledning og overflate',
    NS3451_227: '227 (Reservert)',
    NS3451_228: '228 Utstyr og komplettering for bærende konstruksjoner',
    NS3451_229: '229 Andre deler av bærende konstruksjoner',
    NS3451_23: '23 Yttervegger',
    NS3451_231: '231 Bærende yttervegger',
    NS3451_232: '232 Ikke-bærende yttervegger',
    NS3451_233: '233 Glassfasader',
    NS3451_234: '234 Vinduer, dører, porter',
    NS3451_235: '235 Utvendig kledning og overflate',
    NS3451_236: '236 Innvendig overflate',
    NS3451_237: '237 Solavskjerming',
    NS3451_238: '238 Utstyr og komplettering for yttervegger',
    NS3451_239: '239 Andre deler av yttervegg',
    NS3451_24: '24 Innervegger',
    NS3451_241: '241 Bærende innervegger',
    NS3451_242: '242 Ikke-bærende innervegger',
    NS3451_243: '243 Systemvegger og glassfelt',
    NS3451_244: '244 Vinduer, dører, foldevegger',
    NS3451_245: '245 Skjørt',
    NS3451_246: '246 Kledning og overflate',
    NS3451_247: '247 (Reservert)',
    NS3451_248: '248 Utstyr og komplettering for innervegger',
    NS3451_249: '249 Andre deler av innervegg',
    NS3451_25: '25 Dekker',
    NS3451_251: '251 Frittbærende dekker',
    NS3451_252: '252 Gulv på grunn, bunnplate',
    NS3451_253: '253 Oppfôret gulv og påstøp',
    NS3451_254: '254 Systemgulv',
    NS3451_255: '255 Gulvoverflate',
    NS3451_256: '256 Faste himlinger og overflatebehandling',
    NS3451_257: '257 Systemhimlinger',
    NS3451_258: '258 Utstyr og komplettering for dekker',
    NS3451_259: '259 Andre deler av dekker',
    NS3451_26: '26 Yttertak',
    NS3451_261: '261 Primærkonstruksjon for yttertak',
    NS3451_262: '262 Taktekking',
    NS3451_263: '263 Glasstak, overlys, takluker, røykluker',
    NS3451_264: '264 Takoppbygg',
    NS3451_265: '265 Gesimser, takrenner og nedløp',
    NS3451_266: '266 Himling og innvendig overflate',
    NS3451_267: '267 Prefabrikkerte takelementer',
    NS3451_268: '268 Utstyr og kompletteringer for yttertak',
    NS3451_269: '269 Andre deler av yttertak',
    NS3451_27: '27 Fast inventar',
    NS3451_271: '271 Murte piper og ildsteder',
    NS3451_272: '272 Monteringsferdige ildsteder',
    NS3451_273: '273 Kjøkkeninnredning',
    NS3451_274: '274 Innredning og garnityr for våtrom',
    NS3451_275: '275 Skap og reoler',
    NS3451_276: '276 Sittebenker, stolrader, bord',
    NS3451_277: '277 Skilt og tavler',
    NS3451_278: '278 Utstyr og kompletteringer for fast inventar',
    NS3451_279: '279 Annet fast inventar',
    NS3451_28: '28 Trapper, balkonger, m.m.',
    NS3451_281: '281 Innvendige trapper',
    NS3451_282: '282 Utvendige trapper',
    NS3451_283: '283 Ramper',
    NS3451_284: '284 Balkonger og verandaer',
    NS3451_285: '285 Tribuner og amfier',
    NS3451_286: '286 Baldakiner og skjermtak',
    NS3451_287: '287 Andre rekkverk, håndlister og fendere',
    NS3451_288: '288 Utstyr og kompletteringer for trapper, balkonger m.m.',
    NS3451_289: '289 Andre trapper, balkonger m.m.',
    NS3451_29: '29 Andre bygningsmessige deler',
    NS3451_291: '291 Hull, tettinger',
    NS3451_3: '3 VVS-installasjoner',
    NS3451_31: '31 Sanitær',
    NS3451_310: '310 Sanitæranlegg',
    NS3451_311: '311 Bunnledninger for sanitærinstallasjoner',
    NS3451_312: '312 Ledningsnett for sanitærinstallasjoner',
    NS3451_314: '314 Armaturer for sanitærinstallasjoner',
    NS3451_315: '315 Utstyr for sanitærinstallasjoner',
    NS3451_316: '316 Isolasjon av sanitærinstallasjoner',
    NS3451_319: '319 Andre deler av sanitærinstallasjoner',
    NS3451_32: '32 Varme',
    NS3451_320: '320 Varmeanlegg',
    NS3451_321: '321 Bunnledninger for varmeinstallasjoner',
    NS3451_322: '322 Ledningsnett for varmeinstallasjoner',
    NS3451_324: '324 Armaturer for varmeinstallasjon',
    NS3451_325: '325 Utstyr for varmeinstallasjoner',
    NS3451_326: '326 Isolasjon av varmeinstallasjoner',
    NS3451_329: '329 Andre deler av varmeinstallasjoner',
    NS3451_33: '33 Brannslokking',
    NS3451_330: '330 Brannslokking',
    NS3451_331: '331 Installasjon for manuell brannslokking med vann',
    NS3451_332: '332 Installasjon for brannslokking med sprinkler',
    NS3451_333: '333 Installasjon for brannslokking med vanntåke',
    NS3451_334: '334 Installasjon for brannslokking med pulver',
    NS3451_335: '335 Installasjon for brannslokking med gass',
    NS3451_336: '336 Installasjon for brannslokking med skum',
    NS3451_337: '337 Brannslokking med håndslukker',
    NS3451_339: '339 Andre deler av installasjoner for brannslokking',
    NS3451_34: '34 Gass og trykkluft',
    NS3451_340: '340 Gass- og trykkluftslokking',
    NS3451_341: '341 Installasjon for gass til bygningsdrift',
    NS3451_342: '342 Installasjon for gass til virksomhet',
    NS3451_343: '343 Installasjon for medisinske gasser',
    NS3451_345: '345 Installasjon for trykkluft til virksomhet',
    NS3451_346: '346 Installasjon for medisinsk trykkluft',
    NS3451_347: '347 Installasjon for vakuumanlegg',
    NS3451_348: '348 Spesialavtrekk for gasser',
    NS3451_349: '349 Andre deler av installasjoner for gass og trykkluft',
    NS3451_35: '35 Varmepumpe- og kuldeinstallasjoner',
    NS3451_350: '350 Prosesskjøling',
    NS3451_351: '351 Installasjon for kjøling av kjølerom',
    NS3451_352: '352 Installasjon for kjøling av fryserom',
    NS3451_353: '353 Installasjon til kjøling for virksomhet',
    NS3451_354: '354 Installasjoner til kjøling og varme for industri og produksjon',
    NS3451_355: '355 Installasjoner til kjøling for innendørs idrettsbaner',
    NS3451_356: '356 Installasjoner for oppvarming og kjøling i bygg',
    NS3451_359: '359 Andre deler for varmepumpe- og kuldeinstallasjoner',
    NS3451_36: '36 Luftbehandling',
    NS3451_360: '360 Ventilasjon',
    NS3451_361: '361 Kanalnett i grunnen for luftbehandling',
    NS3451_362: '362 Kanalnett for luftbehandling',
    NS3451_364: '364 Utstyr for luftfordeling',
    NS3451_365: '365 Utstyr for luftbehandling',
    NS3451_366: '366 Isolasjon av installasjon for luftbehandling',
    NS3451_37: '37 Komfortkjøling',
    NS3451_370: '370 Komfortkjøling',
    NS3451_371: '371 Ledningsnett i grunnen for komfortkjøling',
    NS3451_372: '372 Ledningsnett for komfortkjøling',
    NS3451_374: '374 Armaturer for komfortkjøling',
    NS3451_375: '375 Utstyr for komfortkjøling',
    NS3451_376: '376 Isolasjon av installasjon for komfortkjøling',
    NS3451_379: '379 Andre deler for komfortkjøling',
    NS3451_38: '38 Vannbehandling',
    NS3451_380: '380 Vannbehandling',
    NS3451_381: '381 Installasjon for rensing av vann',
    NS3451_382: '382 Installasjon for rensing av avløpsvann',
    NS3451_383: '383 Installasjon for vannrensing til svømmebasseng',
    NS3451_386: '386 Innendørs fontener og springvann',
    NS3451_389: '389 Andre deler for vannbehandling',
    NS3451_39: '39 Andre VVS-installasjoner',
    NS3451_4: '4 Elkraftinstallasjoner',
    NS3451_41: '41 Basisinstallasjoner for elkraft',
    NS3451_411: '411 Kabelføring for elkraftinstallasjoner',
    NS3451_412: '412 Jording for elkraftinstallasjoner',
    NS3451_413: '413 Lynvern',
    NS3451_414: '414 Installasjoner for elkraftuttak',
    NS3451_419: '419 Andre basisinstallasjoner for elkraft',
    NS3451_42: '42 Høyspent forsyning',
    NS3451_421: '421 Installasjoner for høyspent fordeling',
    NS3451_422: '422 Nettstasjoner',
    NS3451_429: '429 Andre deler for høyspent forsyning',
    NS3451_43: '43 Lavspent forsyning',
    NS3451_431: '431 Installasjoner for elkraftinntak',
    NS3451_432: '432 Installasjoner for hovedfordeling',
    NS3451_433: '433 Elkraftfordeling til alminnelig forbruk',
    NS3451_434: '434 Elkraftfordeling til driftstekniske installasjoner',
    NS3451_435: '435 Elkraftfordeling til virksomhet',
    NS3451_436: '436 Elkraftfordeling til lading',
    NS3451_439: '439 Andre deler for lavspent forsyning',
    NS3451_44: '44 Lys',
    NS3451_442: '442 Belysning',
    NS3451_443: '443 Nødlys',
    NS3451_449: '449 Andre deler for installasjoner for lys',
    NS3451_45: '45 Elvarme',
    NS3451_452: '452 Varmeovner',
    NS3451_453: '453 Varmeelementer for innbygging',
    NS3451_454: '454 Vannvarmere og elektrokjeler',
    NS3451_459: '459 Annen elvarme',
    NS3451_46: '46 Reservekraft',
    NS3451_461: '461 Elkraftaggregater',
    NS3451_462: '462 Avbruddsfri kraftforsyning',
    NS3451_463: '463 Akkumulatoranlegg',
    NS3451_469: '469 Andre deler for reservekraftforsyning',
    NS3451_47: '47 Lokal elkraftproduksjon',
    NS3451_471: '471 Solceller',
    NS3451_472: '472 Vindmøller',
    NS3451_479: '479 Andre deler for lokal elkraftproduksjon',
    NS3451_48: '48 Installasjon for elektrisk beskyttelse',
    NS3451_481: '481 Elektrisk korrosjonsbeskyttelse',
    NS3451_482: '482 Elektrisk sikkerhet for forebygging mot uønskede hendelser',
    NS3451_489: '489 Andre deler for installasjon for elektrisk beskyttelse',
    NS3451_49: '49 Andre elkraftinstallasjoner',
    NS3451_5: '5 Ekom og automatisering',
    NS3451_51: '51 Basisinstallasjoner for ekom og automatisering',
    NS3451_511: '511 Kabelføring',
    NS3451_512: '512 Jording',
    NS3451_514: '514 Inntak for ekom og automatisering',
    NS3451_515: '515 Fordelinger for ekom og automatisering',
    NS3451_519: '519 Andre basisinstallasjoner for ekom og automatisering',
    NS3451_52: '52 Integrert kommunikasjon',
    NS3451_521: '521 Kabling for ekom og automatisering',
    NS3451_522: '522 Nettutstyr',
    NS3451_523: '523 Sentralutstyr',
    NS3451_524: '524 Terminalutstyr',
    NS3451_529: '529 Andre deler for integrert kommunikasjon',
    NS3451_53: '53 Telefoni og personsøkning',
    NS3451_532: '532 Telefoni',
    NS3451_533: '533 Nødkommunikasjon',
    NS3451_534: '534 Porttelefoner',
    NS3451_535: '535 Høyttalende hustelefoner',
    NS3451_536: '536 Personsøkning',
    NS3451_539: '539 Andre deler for telefoni og personsøkning',
    NS3451_54: '54 Alarm og signal',
    NS3451_542: '542 Brannalarm',
    NS3451_543: '543 Adgangskontroll, innbrudds- og overfallsalarm',
    NS3451_544: '544 Pasientsignal',
    NS3451_545: '545 Uranlegg og tidsregistrering',
    NS3451_546: '546 Alarm knyttet til bygning eller installasjon',
    NS3451_549: '549 Andre deler for alarm og signal',
    NS3451_55: '55 Lyd og bilde',
    NS3451_552: '552 Fellesantenner',
    NS3451_553: '553 Internfjernsyn',
    NS3451_554: '554 Lyddistribusjonsanlegg',
    NS3451_555: '555 Lydanlegg',
    NS3451_556: '556 Bilde og AV',
    NS3451_559: '559 Andre deler for lyd og bilde',
    NS3451_56: '56 Automatisering',
    NS3451_562: '562 Sentral driftskontroll og automatisering',
    NS3451_563: '563 Lokal automatisering',
    NS3451_564: '564 Installasjoner for buss-systemer',
    NS3451_565: '565 Installasjoner for FDVUS: Administrative systemer',
    NS3451_569: '569 Andre deler for automatisering',
    NS3451_57: '57 Instrumentering',
    NS3451_571: '571 Kabling for instrumentering',
    NS3451_572: '572 Instrumentering for måling av mengde',
    NS3451_573: '573 Instrumentering for måling av trykk',
    NS3451_574: '574 Instrumentering for måling av temperatur',
    NS3451_575: '575 Instrumentering for måling av lengde',
    NS3451_576: '576 Instrumentering for måling av vekt',
    NS3451_577: '577 Instrumentering for måling av elektriske størrelser',
    NS3451_578: '578 Instrumentering for analyse',
    NS3451_579: '579 Annen instrumentering',
    NS3451_58: '58 (Reservert)',
    NS3451_59: '59 Andre installasjoner for ekom og automatisering',
    NS3451_6: '6 Andre installasjoner',
    NS3451_61: '61 Prefabrikkerte rom',
    NS3451_611: '611 Prefabrikkerte kjølerom',
    NS3451_612: '612 Prefabrikkerte fryserom',
    NS3451_613: '613 Prefabrikkerte baderom',
    NS3451_614: '614 Prefabrikkerte skjermrom',
    NS3451_615: '615 Prefabrikkerte moduler for sjakter og himlinger',
    NS3451_619: '619 Andre prefabrikkerte rom',
    NS3451_62: '62 Person- og varetransport',
    NS3451_621: '621 Heiser',
    NS3451_622: '622 Rulletrapper',
    NS3451_623: '623 Rullebånd',
    NS3451_624: '624 Løftebord',
    NS3451_625: '625 Trappeheiser',
    NS3451_626: '626 Kraner',
    NS3451_627: '627 Fasade- og takvask',
    NS3451_629: '629 Annen person- og varetransport',
    NS3451_63: '63 Transportanlegg',
    NS3451_631: '631 Dokument- og småvaretransportører',
    NS3451_632: '632 Transportanlegg for tørr og løs masse',
    NS3451_633: '633 Transportanlegg for drivstoff, olje og kjemikalier',
    NS3451_634: '634 Selvgående transportører',
    NS3451_639: '639 Andre transportanlegg',
    NS3451_64: '64 Scene teknisk utstyr',
    NS3451_65: '65 Avfall og støvsuging',
    NS3451_651: '651 Utstyr for oppsamling og behandling av avfall',
    NS3451_652: '652 Sentralstøvsuger',
    NS3451_653: '653 Pneumatisk søppeltransport',
    NS3451_659: '659 Andre installasjoner for avfall og støvsuging',
    NS3451_66: '66 Fastmontert spesialutrustning for virksomhet',
    NS3451_661: '661 Utstyr for fastmontert spesialutrustning for virksomhet',
    NS3451_67: '67 Løs spesialutrustning for virksomhet',
    NS3451_681: '681 Deler til inventar',
    NS3451_69: '69 Andre tekniske installasjoner',
    NS3451_7: '7 Utendørs',
    NS3451_71: '71 Bearbeidet terreng',
    NS3451_711: '711 Grovplanert terreng',
    NS3451_712: '712 Drenering',
    NS3451_713: '713 Forsterket grunn',
    NS3451_714: '714 Grøfter og groper for tekniske installasjoner',
    NS3451_715: '715 Bergrom',
    NS3451_719: '719 Annen terrengbearbeiding',
    NS3451_72: '72 Utendørs konstruksjoner',
    NS3451_721: '721 Utendørs støttemurer og andre murer',
    NS3451_722: '722 Utendørs trapper, ramper, terrasser, platting terreng',
    NS3451_723: '723 Utendørs skjermtak, leskur m.m. som henger sammen med bygning',
    NS3451_724: '724 Utendørs svømmebassenger m.m.',
    NS3451_725: '725 Utendørs gjerder, porter og bommer',
    NS3451_726: '726 Utendørs kanaler og kulverter for tekniske installasjoner',
    NS3451_727: '727 Utendørs kummer og tanker for tekniske installasjoner',
    NS3451_729: '729 Andre utendørs konstruksjoner',
    NS3451_73: '73 Utendørs røranlegg',
    NS3451_731: '731 Utendørs VA',
    NS3451_732: '732 Utendørs varme',
    NS3451_733: '733 Utendørs brannslokking',
    NS3451_734: '734 Utendørs gassinstallasjoner',
    NS3451_735: '735 Utendørs kjøling for idrettsbaner',
    NS3451_736: '736 Utendørs luftbehandling',
    NS3451_737: '737 Utendørs forsyningsanlegg for termisk energi',
    NS3451_738: '738 Utendørs fontener og springvann',
    NS3451_739: '739 Andre utendørs røranlegg',
    NS3451_74: '74 Utendørs elkraft',
    NS3451_742: '742 Utendørs høyspent forsyning',
    NS3451_743: '743 Utendørs lavspent forsyning',
    NS3451_744: '744 Utendørs lys',
    NS3451_745: '745 Utendørs elvarme',
    NS3451_746: '746 Utendørs reservekraft',
    NS3451_749: '749 Andre installasjoner for utendørs elkraft',
    NS3451_75: '75 Utendørs ekom og automatisering',
    NS3451_752: '752 Utendørs integrert kommunikasjon',
    NS3451_753: '753 Utendørs telefoni og personsøkning',
    NS3451_754: '754 Utendørs alarm og signal',
    NS3451_755: '755 Utendørs lyd og bilde',
    NS3451_756: '756 Utendørs automatisering',
    NS3451_759: '759 Andre installasjoner for utendørs ekom og automatisering',
    NS3451_76: '76 Veier og plasser',
    NS3451_761: '761 Veier',
    NS3451_762: '762 Plasser',
    NS3451_763: '763 Utendørs skilter',
    NS3451_764: '764 Utendørs sikkerhetsrekkverk, awisere, guard-rail m.m.',
    NS3451_769: '769 Andre deler for veier og plasser',
    NS3451_77: '77 Park og grøntanlegg',
    NS3451_771: '771 Utendørs gressarealer',
    NS3451_772: '772 Utendørs beplantning',
    NS3451_773: '773 Utendørs utstyr',
    NS3451_774: '774 Utendørs plasser for idrett og kultur',
    NS3451_775: '775 Utendørs tribuner og amfier',
    NS3451_779: '779 Andre deler for park og grøntanlegg',
    NS3451_78: '78 Utendørs infrastruktur',
    NS3451_783: '783 Utendørs tilknytning til eksterne nett for vannforsyning, avløp og fjernvarme',
    NS3451_784: '784 Utendørs tilknytning til eksternt elkraftnett',
    NS3451_785: '785 Utendørs tilknytning til eksternt telenett',
    NS3451_789: '789 Andre deler for utendørs infrastruktur',
    NS3451_79: '79 Andre utendørs anlegg',
  },
  OMUK: {
    UNCATEGORIZED: 'Uncategorized',
    OMUK_1: '1 H&S File',
    OMUK_1_1: '11 Introduction',
    OMUK_1_1_1: '111 Introduction and Description',
    OMUK_1_1_2: '112 Project Directory',
    OMUK_1_2: '12 Design Criteria',
    OMUK_1_2_1: '121 Architectural Specifications',
    OMUK_1_2_2: '122 Structural Specifications',
    OMUK_1_2_3: '123 Civil Specifications',
    OMUK_1_2_4: '124 MEP Specifications',
    OMUK_1_2_5: '125 Landscape Specifications',
    OMUK_1_2_6: '126 Acoustic Specifications',
    OMUK_1_3: '13 Residual Hazards & Future Risks',
    OMUK_1_4: '14 Strategy Documents',
    OMUK_1_4_1: '141 Access Strategy',
    OMUK_1_4_2: '142 Fire & Evacuation Strategy',
    OMUK_1_4_3: '143 Refuse & Waste Management Strategy',
    OMUK_1_5: '15 GA & Schematic Drawings',
    OMUK_1_5_1: '151 Architectural',
    OMUK_1_5_2: '152 Structural',
    OMUK_1_5_3: '153 Civil',
    OMUK_1_5_4: '154 MEP',
    OMUK_1_5_5: '155 Landscape',

    OMUK_2: '2 Regulation 38 / Fire Safety Manual',
    OMUK_2_1: '21 Regulation 38 / Fire Safety Manual  Summary',
    OMUK_2_2: '22 Fire Safety Risk Assessment',
    OMUK_2_3: '23 Fire Strategy',
    OMUK_2_4: '24 Maintenance',
    OMUK_2_5: '25 Cause and Effect',
    OMUK_2_6: '26 CFD',
    OMUK_2_7: '27 Certification',

    OMUK_3: '3 Golden Thread',
    OMUK_3_1: '31 Golden Thread Summary',
    OMUK_3_2: '32 Façade Build Up Record',
    OMUK_3_3: '33 Audit Minutes',
    OMUK_3_4: '34 QA Documentation',
    OMUK_3_5: '35 Fire Engineers Reports',
    OMUK_3_6: '36 Test / Certification',
    OMUK_3_7: '37 EWS1',
    OMUK_3_8: '38 Supporting Information',

    OMUK_4: '4 Sitewide Information & Infrastructure',
    OMUK_4_1: '41 Heating / Cooling Networks',
    OMUK_4_1_1: '411 Strategy & Calculations',
    OMUK_4_1_2: '412 O&M Manual',
    OMUK_4_1_3: '413 Testing / Commissioning & Sign Off Certificates',
    OMUK_4_1_4: '414 As Built Drawings / Installation Record Keeping',
    OMUK_4_2: '42 Water',
    OMUK_4_2_1: '421 Strategy & Calculations',
    OMUK_4_2_2: '422 O&M Manual',
    OMUK_4_2_3: '423 Testing / Commissioning & Sign Off Certificates',
    OMUK_4_2_4: '424 As Built Drawings / Installation Record Keeping',
    OMUK_4_3: '43 Gas',
    OMUK_4_3_1: '431 Strategy & Calculations',
    OMUK_4_3_2: '432 O&M Manual',
    OMUK_4_3_3: '433 Testing / Commissioning & Sign Off Certificates',
    OMUK_4_3_4: '434 As Built Drawings / Installation Record Keeping',
    OMUK_4_4: '44 Drainage ',
    OMUK_4_4_1: '441 Strategy & Calculations',
    OMUK_4_4_2: '442 O&M Manual',
    OMUK_4_4_3: '443 Testing / Commissioning & Sign Off Certificates',
    OMUK_4_4_4: '444 As Built Drawings / Installation Record Keeping',
    OMUK_4_5: '45 Electrical ',
    OMUK_4_5_1: '451 Strategy & Calculations',
    OMUK_4_5_2: '452 O&M Manual',
    OMUK_4_5_3: '453 Testing / Commissioning & Sign Off Certificates',
    OMUK_4_5_4: '454 As Built Drawings / Installation Record Keeping',
    OMUK_4_6: '46 Roads/ Civil ',
    OMUK_4_6_1: '461 Strategy & Calculations',
    OMUK_4_6_2: '462 O&M Manual',
    OMUK_4_6_3: '463 Testing / Commissioning & Sign Off Certificates',
    OMUK_4_6_4: '464 As Built Drawings / Installation Record Keeping',
    OMUK_4_7: '47 Telecoms',
    OMUK_4_7_1: '471 Strategy & Calculations',
    OMUK_4_7_2: '472 O&M Manual',
    OMUK_4_7_3: '473 Testing / Commissioning & Sign Off Certificates',
    OMUK_4_7_4: '474 As Built Drawings / Installation Record Keeping',
    OMUK_4_8: '48 Planning Permission ',
    OMUK_4_8_1: '481 Documentation',

    OMUK_5: '5 Building',
    OMUK_5_1: '51 Kitchens ',
    OMUK_5_1_1: '511 O&M Manual',
    OMUK_5_1_2: '512 Testing & Sign Off Certificates',
    OMUK_5_1_3: '513 As Built Drawings',
    OMUK_5_1_4: '514 Appendices',
    OMUK_5_2: '52 Carpentry & Joinery ',
    OMUK_5_2_1: '521 O&M Manual',
    OMUK_5_2_2: '522 Testing & Sign Off Certificates',
    OMUK_5_2_3: '523 As Built Drawings',
    OMUK_5_2_4: '524 Appendices',
    OMUK_5_3: '53 Ceramic Tiling',
    OMUK_5_3_1: '531 O&M Manual',
    OMUK_5_3_2: '532 Testing & Sign Off Certificates',
    OMUK_5_3_3: '533 As Built Drawings',
    OMUK_5_3_4: '534 Appendices',
    OMUK_5_4: '54 Decorations',
    OMUK_5_4_1: '541 O&M Manual',
    OMUK_5_4_2: '542 Testing & Sign Off Certificates',
    OMUK_5_4_3: '543 H&S/ COSHH Information',
    OMUK_5_4_4: '544 Appendices',
    OMUK_5_5: '55 Dry Lining ',
    OMUK_5_5_1: '551 O&M Manual',
    OMUK_5_5_2: '552 Testing & Sign Off Certificates',
    OMUK_5_5_3: '553 H&S/ COSHH Information',
    OMUK_5_5_4: '554 Appendices',
    OMUK_5_6: '56 Brickwork',
    OMUK_5_6_1: '561 O&M Manual',
    OMUK_5_6_2: '562 Testing & Sign Off Certificates',
    OMUK_5_6_3: '563 Appendices',
    OMUK_5_7: '57 Flooring ',
    OMUK_5_7_1: '571 O&M Manual',
    OMUK_5_7_2: '572 Testing & Sign Off Certificates',
    OMUK_5_7_3: '573 Appendices',
    OMUK_5_8: '58 Appliances / White Goods',
    OMUK_5_8_1: '581 O&M Manual',
    OMUK_5_8_2: '582 Testing & Sign Off Certificates',
    OMUK_5_8_3: '583 Appendices',
    OMUK_5_9: '59 Windows, Doors, Curtain Walling & Cladding',
    OMUK_5_9_1: '591 O&M Manual',
    OMUK_5_9_2: '592 Testing & Sign Off Certificates',
    OMUK_5_9_3: '593 As Built Drawings',
    OMUK_5_9_4: '594 H&S / COSHH information ',
    OMUK_5_9_5: '595 Appendices',
    OMUK_5_10: '510 Roof Waterproofing',
    OMUK_5_10_1: '5101 O&M Manual',
    OMUK_5_10_2: '5102 Testing & Sign Off Certificates',
    OMUK_5_10_3: '5103 As Built Drawings',
    OMUK_5_10_4: '5104 H&S/ COSHH Information',
    OMUK_5_10_5: '5105 Appendices',
    OMUK_5_11: '511 Groundworks / Drainage',
    OMUK_5_11_1: '5111 O&M Manual',
    OMUK_5_11_2: '5112 Testing & Sign Off Certificates',
    OMUK_5_11_3: '5113 As Built Drawings',
    OMUK_5_11_4: '5114 Appendices',
    OMUK_5_12: '512 Landscaping',
    OMUK_5_12_1: '5121 O&M Manual',
    OMUK_5_12_2: '5122 Testing & Sign Off Certificates',
    OMUK_5_12_3: '5123 As Built Drawings',
    OMUK_5_12_4: '5124 Appendices',
    OMUK_5_13: '513 Metalwork',
    OMUK_5_13_1: '5131 O&M Manual',
    OMUK_5_13_2: '5132 Testing & Sign Off Certificates',
    OMUK_5_13_3: '5133 As Built Drawings',
    OMUK_5_13_4: '5134 Appendices',
    OMUK_5_14: '514 Structure',
    OMUK_5_14_1: '5141 O&M Manual',
    OMUK_5_14_2: '5142 Testing & Sign Off Certificates',
    OMUK_5_14_3: '5143 As Built Drawings',
    OMUK_5_14_4: '5144 Appendices',
    OMUK_5_15: '515 Fire Stopping & Fire Protection',
    OMUK_5_15_1: '5151 O&M Manual',
    OMUK_5_15_2: '5152 Testing & Sign Off Certificates',
    OMUK_5_15_3: '5153 As Built Drawings / Installation Records',
    OMUK_5_15_4: '5154 Appendices',
    OMUK_5_15_5: '5155 H&S/ COSHH Information',
    OMUK_5_16: '516 Lifts ',
    OMUK_5_16_1: '5161 O&M Manual',
    OMUK_5_16_2: '5162 Testing & Sign Off Certificates',
    OMUK_5_16_3: '5163 As Built Drawings ',
    OMUK_5_16_4: '5164 Appendices',
    OMUK_5_17: '517 Lightning Protection',
    OMUK_5_17_1: '5171 O&M Manual',
    OMUK_5_17_2: '5172 Testing & Sign Off Certificates',
    OMUK_5_17_3: '5173 As Built Drawings ',
    OMUK_5_17_4: '5174 Appendices',
    OMUK_5_18: '518 Mechanical Services',
    OMUK_5_18_1: '5181 O&M Manual',
    OMUK_5_18_2: '5182 Testing/ Commissioning & Sign Off Certificates',
    OMUK_5_18_3: '5183 As Built Drawings / Installation Record Keeping',
    OMUK_5_18_4: '5184 Appendices',
    OMUK_5_19: '519 Electrical Services',
    OMUK_5_19_1: '5191 O&M Manual',
    OMUK_5_19_2: '5192 Testing/ Commissioning & Sign Off Certificates',
    OMUK_5_19_3: '5193 As Built Drawings / Installation Record Keeping',
    OMUK_5_19_4: '5194 Appendices',
    OMUK_5_20: '520 Public Health ',
    OMUK_5_20_1: '5201 O&M Manual',
    OMUK_5_20_2: '5202 Testing/ Commissioning & Sign Off Certificates',
    OMUK_5_20_3: '5203 As Built Drawings / Installation Record Keeping',
    OMUK_5_20_4: '5204 Appendices',
    OMUK_5_21: '521 Certification',
    OMUK_5_21_1: '5211 Air Tightness Testing',
    OMUK_5_21_2: '5212 Acoustic Testing',
    OMUK_5_21_3: '5213 EPC Certificate ',
    OMUK_5_21_4: '5214 SAP Certificate',
    OMUK_5_21_5: '5215 SBD Certification',
    OMUK_5_21_6: '5216 NHBC  Final Certification',
    OMUK_5_21_7: '5217 Building Control Certificate / Building Registration Certificate ',
    OMUK_5_21_8: '5218 Fire Risk Assessment',
    OMUK_5_21_9: '5219 Contamination Verification Report (if Required)',
    OMUK_5_21_10: '52110 CDM Handover',
    OMUK_5_21_11: '52111 Practical Completion Statements',

    OMUK_6: '6 Digital Handover',
    OMUK_6_1: '61 BIM Model',
    OMUK_6_2: '62 Asset Data',
  },
};
